export function formatPrice( factor,price){
const formatedPrice = price / factor 
  if (!factor || factor === 0) return price;

  
  if(factor === 100) {
    return formatedPrice.toFixed(2)
  }else if(factor === 1000){
  return formatedPrice.toFixed(3)
  } 
}
